import { ContractType } from '~/graphql/__generated__/operations/ltms';

const DICTIONARIES = {
  en: {
    agreement: 'Upload Agreement',
    all_in: 'All In',
    code: 'Contract Code',
    contract: 'Contract',
    contract_type: {
      [ContractType.Dedicated]: 'Dedicated',
      [ContractType.Oncall]: 'On-Call',
    },
    contracts: 'Contracts',
    dedicate_to_contract: 'Dedicated To Contract',
    driver_only_rental: 'Driver Only Rental',
    fleet_and_driver_rental: 'Fleet and Driver Rental',
    fleet_only_rental: 'Fleet Only Rental',
    included_in_rental_price: 'Included in Rental Price',
    need_additional_cod_fee: 'Need Additional Cod Fee',
    type: 'Contract Type',
    x_and_n_others: '{{x}} and {{n}} others',
  },
};

export default DICTIONARIES;
